import { Component, Input } from '@angular/core';
import { ICellRendererParams } from "ag-grid-community";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
  selector: 'app-ag-multiple-rows',
  standalone: true,
  imports: [
  ],
  templateUrl: './ag-multiple-rows.component.html',
  styleUrl: './ag-multiple-rows.component.scss'
})
export class AgMultipleRowsComponent implements ICellRendererAngularComp {
  @Input() strings: string[] = [];
  @Input() rowClass = '';
  @Input() wrapperClass = '';

  agInit(params: ICellRendererParams): void {
    this.init(params);
  }

  refresh(params: ICellRendererParams): boolean {
    return this.init(params);
  }

  private init(params: ICellRendererParams): boolean {
    this.strings = params.value ?? [];
    this.rowClass = params?.['rowClass'] ?? '';
    this.wrapperClass = params?.['wrapperClass'] ?? '';
    return true;
  }
}
